export const TAGS = {
  //plural
  newsArticles: "newsArticles",
  postArticles: "postArticles",
  interviewArticles: "interviewArticles",
  dailySpotifyRecommendations: "dailySpotifyRecommendations",
  homeSections: "homeSections",
  musicSections: "musicSections",
  events: "events",
  artists: "artists",
  tracks: "tracks",
  releases: "releases",
  sets: "sets",
  authors: "authors",
  glossaryTerms: "glossaryTerms",
};
